import script from "./basic-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./basic-modal.vue?vue&type=script&setup=true&lang=js"

import "./basic-modal.vue?vue&type=style&index=0&id=9222f760&lang=css"
import "./basic-modal.vue?vue&type=style&index=1&id=9222f760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9222f760"]])

export default __exports__